"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function LanguageSwitcher(_a) {
    var setLanguage = _a.setLanguage, currentLang = _a.currentLang, options = _a.options;
    // Filter out the current language to only show unselected languages
    var unselectedOptions = React.useMemo(function () {
        return options.filter(function (option) { return option.code1 !== currentLang; });
    }, [currentLang, options]);
    return (React.createElement("div", { className: "l-mega__langs" },
        React.createElement("div", { className: "l-mega__langs__list" }, unselectedOptions.map(function (option, index) { return (React.createElement(React.Fragment, { key: option.id },
            React.createElement("div", { className: "l-mega__langs__item", onClick: setLanguage(option.id) }, option.shortName),
            index !== unselectedOptions.length - 1 && (React.createElement("div", { className: "l-mega__langs__divider" })))); }))));
}
exports.default = LanguageSwitcher;
